import { WEB_SDK_INSTANCE } from '@sxm-core/utility-code/angular/configuration-token-web-sdk';
import { IWebSDK } from '@sxm-de/dev-kits/web-sdk/core';

export function provideWebSdkInstance(webSdk: IWebSDK) {
    return [
        {
            provide: WEB_SDK_INSTANCE,
            useValue: webSdk,
        },
    ];
}
